"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStats = void 0;
const web3_js_1 = require("@solana/web3.js");
const pollingUserStatsAccountSubscriber_1 = require("./accounts/pollingUserStatsAccountSubscriber");
const webSocketUserStatsAccountSubsriber_1 = require("./accounts/webSocketUserStatsAccountSubsriber");
const pda_1 = require("./addresses/pda");
class UserStats {
    constructor(config) {
        var _a, _b;
        this.driftClient = config.driftClient;
        this.userStatsAccountPublicKey = config.userStatsAccountPublicKey;
        if (((_a = config.accountSubscription) === null || _a === void 0 ? void 0 : _a.type) === 'polling') {
            this.accountSubscriber = new pollingUserStatsAccountSubscriber_1.PollingUserStatsAccountSubscriber(config.driftClient.program, config.userStatsAccountPublicKey, config.accountSubscription.accountLoader);
        }
        else if (((_b = config.accountSubscription) === null || _b === void 0 ? void 0 : _b.type) === 'custom') {
            throw new Error('Custom account subscription not yet implemented for user stats');
        }
        else {
            this.accountSubscriber = new webSocketUserStatsAccountSubsriber_1.WebSocketUserStatsAccountSubscriber(config.driftClient.program, config.userStatsAccountPublicKey);
        }
    }
    async subscribe(userStatsAccount) {
        this.isSubscribed = await this.accountSubscriber.subscribe(userStatsAccount);
        return this.isSubscribed;
    }
    async fetchAccounts() {
        await this.accountSubscriber.fetch();
    }
    async unsubscribe() {
        await this.accountSubscriber.unsubscribe();
        this.isSubscribed = false;
    }
    getAccountAndSlot() {
        return this.accountSubscriber.getUserStatsAccountAndSlot();
    }
    getAccount() {
        return this.accountSubscriber.getUserStatsAccountAndSlot().data;
    }
    getReferrerInfo() {
        if (this.getAccount().referrer.equals(web3_js_1.PublicKey.default)) {
            return undefined;
        }
        else {
            return {
                referrer: (0, pda_1.getUserAccountPublicKeySync)(this.driftClient.program.programId, this.getAccount().referrer, 0),
                referrerStats: (0, pda_1.getUserStatsAccountPublicKey)(this.driftClient.program.programId, this.getAccount().referrer),
            };
        }
    }
}
exports.UserStats = UserStats;
